if (!customElements.get('banner-product-carousel')) {
  class BannerProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-bpc-track]');
      if (!this.track) return;

      this.prevButton = this.querySelector('[data-bpc-prev]');
      this.nextButton = this.querySelector('[data-bpc-next]');

      this.prevButton?.addEventListener('click', () => this.scrollBySlide(-1));
      this.nextButton?.addEventListener('click', () => this.scrollBySlide(1));

      this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      this.updateButtons();
    }

    scrollBySlide(direction) {
      const slide = this.track.querySelector('.bpc__slide');
      if (!slide) return;

      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap || '0');
      const amount = slide.getBoundingClientRect().width + gap;

      this.track.scrollBy({
        left: direction * amount,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    updateButtons() {
      if (!this.track) return;

      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const scrollLeft = this.track.scrollLeft;

      if (this.prevButton) {
        this.prevButton.disabled = scrollLeft <= 1;
      }

      if (this.nextButton) {
        this.nextButton.disabled = scrollLeft >= maxScroll - 1;
      }
    }
  }

  customElements.define('banner-product-carousel', BannerProductCarousel);
}
